import type Month from "../entities/month";

export default class MonthOption {
  public readonly label: string;
  public readonly id: Date;

  constructor(public readonly month: Month, start = true) {
    const { month: monthNumber, year, from, to } = this.month;
    this.id = start ? from : to;
    this.label = `${year} - ${monthNumber.toString().padStart(2, "0")}`;
  }

  static makeStartOptions(months: Month[]) {
    return months.map(month => new MonthOption(month, true));
  }

  static makeEndOptions(months: Month[]) {
    return months.map(month => new MonthOption(month, false));
  }
}

export function findMonthOptionByDate(dateValue: string, monthOptions: MonthOption[]) {
  const [year, month] = dateValue.split("-");
  return monthOptions.find(item => item.month.month === parseInt(month) && item.month.year === parseInt(year));
}
